import { AxiosError } from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getMariaData, updateMariaData } from "src/api/maria";

export const useMariaData = () =>
  useQuery<API.Maria.MariaData.Response, AxiosError<API.Maria.MariaData.ErrorResponse>>({
    queryKey: ["maria-data"],
    queryFn: async () => {
      const response = await getMariaData();
      return response.data;
    },
  });

export const useUpdateMariaData = () =>
  useMutation({
    mutationFn: async (data: API.Maria.UpdateMaria.Request) => {
      const response = await updateMariaData(data);
      return response.data;
    },
  });
